<gp-modal [closable]="true" #aiGenerateModal size="md">
  <div class="gp-modal-title">
    <h5>{{ 'TEMPLATE.ai_generate_title' | translate }}</h5>
  </div>

  <div class="gp-modal-body">
    <gp-message *ngIf="errorMessage" [text]="errorMessage" type="danger"></gp-message>
    <form novalidate [formGroup]="aiForm" class="gp-modal-body clearfix">
      <div class="col-md-12">
        <div class="form-group">
          <label for="aiDescription">{{ 'TEMPLATE.ai_description_label' | translate }}
            <span class="required"> *</span>
          </label>
          <textarea class="form-control"
                    formControlName="description"
                    id="aiDescription"
                    rows="5"
                    style="min-height: 150px;"
                    maxlength="2500"
                    [placeholder]="'TEMPLATE.ai_description_placeholder' | translate"
                    test-id="aiDescription">
          </textarea>
          <small class="form-text text-muted text-right">
            {{ aiForm.get('description')?.value?.length || 0 }} / 2500
          </small>
        </div>
      </div>
    </form>
    <div *ngIf="generating" class="col-md-12 text-muted" test-id="aiGenerateStatus">
      <em class="fa fa-light fa-spinner fa-spin"></em>
      <span class="m-l-sm">{{ 'TEMPLATE.ai_status_generating' | translate }}</span>
    </div>
  </div>

  <div class="gp-modal-footer">
    <div class="btn-bar-wrapper">
      <div class="btn-bar btn-bar-sm btn-bar-align-end">
        <button [disabled]="aiForm.invalid || generating"
                (click)="generate()"
                class="btn btn-dark p-x-md"
                test-id="btnAiGenerate">
          <span *ngIf="generating"><em class="fa fa-light fa-spinner fa-spin"></em></span>
          <span *ngIf="!generating">{{ 'TEMPLATE.ai_generate_button' | translate }}</span>
        </button>
        <button (click)="aiGenerateModal.close()"
                type="button"
                [disabled]="generating"
                class="btn btn-secondary p-x-md"
                test-id="btnCancelAiGenerate">
          {{ 'FORMS.cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
</gp-modal>
